export default __webpack_public_path__ + "static/media/kit_svg1.0705a865.svg";